import { render, staticRenderFns } from "./secondarydealerfilestable.vue?vue&type=template&id=c0664982&scoped=true&"
import script from "./secondarydealerfilestable.vue?vue&type=script&lang=js&"
export * from "./secondarydealerfilestable.vue?vue&type=script&lang=js&"
import style0 from "./secondarydealerfilestable.vue?vue&type=style&index=0&id=c0664982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0664982",
  null
  
)

export default component.exports